import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import RoutesTabs from '~/shared/ui/RoutesTabs'
import { useConfigTabs } from './useConfigTabs'

type OrganizationPageProps = {
  listCarRentalPage: ReactNode
  addCarRentalPage: ReactNode
  editCarRentalPage: ReactNode
}

export function OrganizationPage({
  listCarRentalPage,
  addCarRentalPage,
  editCarRentalPage,
}: OrganizationPageProps) {
  const { t } = useTranslation()

  const configTabs = useConfigTabs({
    listCarRentalPage,
    addCarRentalPage,
    editCarRentalPage,
  })
  return (
    <PageContainer title={t('organizations')}>
      <RoutesTabs
        parentPath='/organizations'
        config={configTabs}
        parentContent={
          <Container isHeader>
            <PageTitle>{t('organizations')}</PageTitle>
          </Container>
        }
      />
    </PageContainer>
  )
}
